import React from 'react';
import { render } from 'react-dom';

import { getErrorMessageKey } from '../../util/errorCodes';
import jsonGet from '../../util/jsonGet';

import { formatDate } from '../react/BookingFieldset/helpers';
import ErrorMessage from '../react/Core/ErrorMessage';
import Loading from '../react/Core/Loading';
import PapBookingDetails from '../react/PapBookingDetails';
import ProgressBar from '../react/ProgressBar';

export default class PapBookingDetailsRender {
  constructor(context) {
    this.context = context;
    this.init();
  }

  init() {
    const { apiUrl, model, currentProgressBarStep, pcaPredictKey, loadApi, title } =
      this.context.dataset;
    if (!apiUrl || !model || !pcaPredictKey || !loadApi) throw Error('Missing a required dataset');

    let labels;
    try {
      labels = JSON.parse(model);
    } catch (e) {
      labels = undefined;
      console.error('Error parsing labels json: ', model);
    }

    const urlSearchParams = new URLSearchParams(window.location.search);
    const queryStringValue = urlSearchParams.values().next().value;
    const loadApiUrl = `${loadApi}/${queryStringValue}`;

    jsonGet(loadApiUrl, null, (response) => {
      if (response.errorCode) {
        const errorMessageKey = getErrorMessageKey(response.errorCode);
        return render(
          <ErrorMessage text={labels[errorMessageKey] || response.message} />,
          this.context
        );
      }

      return render(
        PapBookingDetailsRender.renderMain(
          response,
          labels,
          apiUrl,
          title,
          pcaPredictKey,
          currentProgressBarStep
        ),
        this.context
      );
    });

    return render(
      PapBookingDetailsRender.renderMain(
        undefined,
        labels,
        apiUrl,
        title,
        pcaPredictKey,
        currentProgressBarStep
      ),
      this.context
    );
  }

  static renderMain(papBookingDetailsData, labels, apiUrl, title, pcaPredictKey, selectedStep) {
    const data = papBookingDetailsData;

    if (data) {
      // Format Lead Party Member Date of Birth
      if (data.paymentUser.dateOfBirth) {
        data.paymentUser.dateOfBirth = formatDate(data.paymentUser.dateOfBirth);
      }
    }

    return (
      <>
        <ProgressBar steps={data?.progressBarSteps} selectedStep={selectedStep} />
        <div className="PageTitle">
          <h1 className="PageTitle_title">{title}</h1>
        </div>
        {data ? (
          <PapBookingDetails
            data={data}
            labels={labels}
            apiURL={apiUrl}
            pcaPredictKey={pcaPredictKey}
          />
        ) : (
          <Loading />
        )}
      </>
    );
  }
}
